import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import {SchoolCalendar} from 'Src/models/schoolTerm';

export function getSchoolCalendar(user: AppUser): Promise<SchoolCalendar> {
  return axios.get(`${window.apiBase}/i/schools/${user.activeSchoolId}/terms/calendar`, {headers: {usid: user.roleSessionKey}}).then(response => response.data);
}
export function saveSchoolAcademicYear(user: AppUser, body: any, yearId?: string): Promise<SchoolCalendar> {
  const url = `${window.apiBase}/i/schools/${user.activeSchoolId}/terms/calendar${yearId ? `/${yearId}` : ''}`;
  return axios({url, method: yearId ? 'put' : 'post', data: body, headers: {usid: user.roleSessionKey}}).then(response => response.data);
}

export function addSchoolTerms(user: AppUser, data: any) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.post(`${window.apiBase}/i/schools/${activeSchoolId}/terms`, data, config).then(response => {
    return response.data;
  });
}

export function getSchoolTerms(user: AppUser) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.get(`${window.apiBase}/i/schools/${activeSchoolId}/terms`, config).then(response => {
    return response.data;
  });
}

export function updateSchoolTerms(user: AppUser, termId: string, data: any) {
  const { roleSessionKey: key, activeSchoolId } = user;

  const config = {
    headers: { usid: key }
  };

  return axios.put(`${window.apiBase}/i/schools/${activeSchoolId}/terms/${termId}`, data, config).then(response => {
    return response.data;
  });
}
